import Modal from "~/common/components/Modal";
import { Button } from "~/common/components/Button/Button";

import classes from "./SessionExpirePopup.module.less";
import { URL_PARAM_OPEN_LOGIN_POPUP } from "~/Login/loginConstants";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import classNames from "classnames";
import { IMG_STOPWATCH_GRAY } from "~/utils/url/staticResources";
import { useTranslation } from "react-i18next";

export const SessionExpiredPopup = () => {
  const isMinTablet = useIsMinTabletSize();

  const reloadAndLogin = () => {
    window.sessionStorage.setItem(URL_PARAM_OPEN_LOGIN_POPUP, "true");
    window.location.reload();
  };

  const { t } = useTranslation();

  return (
    <Modal
      onClose={reloadAndLogin}
      title={t("popup.autologout.title")}
      footerChildren={
        <Button fullWidth={!isMinTablet} onClick={reloadAndLogin}>
          {t("popup.autologout.btn.login")}
        </Button>
      }
    >
      <div className={classes.content}>
        <div className={classes.text}>{t("popup.autologout.content.expired")}</div>
        {!isMinTablet && <img className={classes.stopwatch} src={IMG_STOPWATCH_GRAY} />}
      </div>
    </Modal>
  );
};
